








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'

@Component({
  components: {}
})
export default class Card extends Vue {

}
